import { ThreeDots } from "react-loader-spinner";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <ThreeDots color="#e05170" height={100} width={100} />
      <p className="loader-text text-2xl">იტვირთება...</p>
    </div>
  );
};

export default Loader;
